
<template>
  <div id="todo-app" class="vs-con-loading__container">
    <!-- <vs-alert color="danger" active="true" class="mt-1 mb-3">
      <h6
        style="font-weight: bolder; color:red; font-style: italic; font-size: 11px;"
      >
        Nota: En caso de tener algún problema, revisa que el traductor de tu
        navegador este desactivado y si aun así sigues teniendo problema, limpia
        el cache de tu navegador.   class="vx-col w-full md:w-1/2 sm:w-1/2 mb-base"
      </h6>
    </vs-alert> -->
    <div class="vx-row mt-base">
      <div
           class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/2 xl:w-1/2 mb-base"
        v-for="asignatura in arrAsignaturas"
        :key="asignatura.clave"
      >
        <vx-card style="height: 15rem;"> 
          <div class="flex vx-row">
            <div class="vx-col w-full md:w-3/4 sm:w-1/2">
              <div style="font-size: 13px;font-weight: bold;">
                {{ asignatura.programaEducativo }}
              </div>
              <div style="font-size: 12px; font-weight: bold; color: gray;">
                {{ asignatura.nombreAsignatura }}
              </div>
              <div style="font-size: 10px;color: gray;">
                Grupo: {{ asignatura.clave }}
              </div>
            </div>
            <div
              class="vx-col w-full md:w-1/4 sm:w-1/2"
              style="text-align: right;"
            >
              <i
                class="vs-icon notranslate icon-scale material-icons null"
                style="font-size: 34px; text-align: left;color: #3c77a5;"
                >assignment</i
              >
            </div>
          </div>

          <vs-divider></vs-divider>

          <div class="flex vx-row text-right">
            <div class="vx-col w-full">
              <router-link 
              :to="{
                  name: 'listadoTareas',
                  params: {
                    idGrupo: asignatura.idGrupo
                  },
                }"
              >
                <vs-button
                  class="mt-4 vs-button-info shadow-sm small color: white;font-family: arial;text-decoration: none;font-size: 12px;"
                >
                  Historial de tareas
                </vs-button>
              </router-link>

              {{ " " }}
             
              <router-link
                :to="{
                  name: 'crearTarea',
                  params: {
                    programaEducativo: asignatura.programaEducativo,
                    nombreAsignatura: asignatura.nombreAsignatura,
                    idGrupo: asignatura.idGrupo,
                    idAsignatura: asignatura.idAsignatura
                  },
                }"
              >
                <vs-button
                  class="mt-4 vs-button-success shadow-sm small color: white;font-family: arial;text-decoration: none;font-size: 12px;"
                >
                  Crear tarea
                </vs-button>
              </router-link>
            </div>
          </div>
        </vx-card>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      arrAsignaturas: [],
    };
  },

  methods: {
    getTasks() {
      fetch(
        `${this.$BASE.baseUrl}api/ListadoGrupos/1/3`,
        {
          method: "GET",
          headers: {
            Authorization: sessionStorage.getItem("token"),
            pagina: "grupos",
            paginaOrigen: "listadoGrupos",
          },
        }
      )
        .then((rs) => rs.json())
        .catch((error) => console.log("error: ", error))
        .then((rs) => {
          if (rs.status === 200) {
            this.arrAsignaturas = rs.result.grupos;
          }
        });
    },
  },
  created() {
    this.getTasks();
  },
};
</script>
